module.exports = __webpack_public_path__ + "img/bleeding-edge-thumbnail.e0d5bb1a.jpg";